import { combineReducers } from '@reduxjs/toolkit';

// Feature slices for UI state
import authReducer from '@features/auth/store/authSlice';
import bookingReducer from '@features/booking/store/bookingSlice';
import roleReducer from '@features/role/store/roleSlice';

// RTK Query base API (includes all API slices)
// This includes: authApi, dashboardApi, driversApi, vehiclesApi, rolesApi, branchesApi
import { baseApi as api } from '@shared/services/api/baseApi';

/**
 * Root Reducer - combines all slices
 * 
 * Structure:
 * - auth: Authentication state (from features/auth)
 * - booking: Booking state (from features/booking)
 * - role: Role state (from features/role)
 * - api: RTK Query API state (all API endpoints)
 */
const rootReducer = combineReducers({
  // Feature slices for UI state management
  auth: authReducer,
  booking: bookingReducer,
  role: roleReducer,
  
  // RTK Query API reducer - handles all API endpoints
  // Includes: authentication, dashboard, drivers, vehicles, roles, branches
  [api.reducerPath]: api.reducer,
});

export default rootReducer;
